import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';

import {contactListColumnIds} from '../../../../../util/uiconstants';
import {labels} from '../../../../../util/utils';

import {IconoirUser} from '@ey-xd/motif-icon';
import OutputText from '@ey/canvascoreservices/OutputText';

import ProfileModal from '../../ProfileModal';
import User from '../../../../CoreWrappers/User';
import Button from '../../../../CoreWrappers/Button';
import Chip from '../../../../CoreWrappers/Chip';

const NameColumn = ({item, entityId, activateProfileModal}) => {
	const [open, setOpen] = useState(false);

	const {userId} = item;

	const project = useSelector(({project}) => project);

	const isProjectOwner = project.users?.filter((user) => user.isProjectOwner)?.some((owner) => owner.userId === userId);
	const isEntityAdmin = project.orgStructure
		?.find((entity) => entity.entityId == entityId)
		?.entityAdmins?.some((admin) => admin.userId === userId);

	const renderProfileModal = () => {
		if (activateProfileModal) {
			const props = {
				profile: item,
				onCloseModal: () => setOpen(false)
			};

			return open && <ProfileModal {...props} />;
		}
		return false;
	};

	const renderBadge = () => {
		const config = {display: isProjectOwner || isEntityAdmin};
		if (isProjectOwner) config.text = labels.projectOwnerBadge;
		if (isEntityAdmin) config.text = labels.entityAdminBadge;

		if (!config.display) return false;

		return (
			<Chip className="user-component-badge">
				<OutputText body3 ellipsis title={config.text}>
					{config.text}
				</OutputText>
			</Chip>
		);
	};

	const props = {
		key: item?.userId,
		firstName: item.name,
		lastName: item.lastName,
		email: item.emailAddress,
		isInternal: item.isInternal,
		showType: true,
		renderExtra: () => {
			const props = {
				svg: IconoirUser,
				title: labels.userProfile,
				onClick: () => setOpen(true),
				variant: 'text',
				iconSize: 20,
				className: 'user-component-controls'
			};

			return <Button {...props} />;
		}
	};

	return (
		<StyledName>
			<User {...props} />
			{renderBadge()}
			{renderProfileModal()}
		</StyledName>
	);
};

export const config = (labels, entityId, activateProfileModal) => ({
	id: contactListColumnIds.name,
	label: labels.columnName,
	propName: 'name',
	width: 'minmax(var(--px-200), 1fr)',
	sortBy: ['name', 'lastName'],
	fixed: true,
	customCell: (item) => {
		const props = {item, entityId, activateProfileModal};
		return <NameColumn {...props} />;
	}
});

const StyledName = styled.div`
	display: flex;
	gap: var(--spacing-medium);
	min-width: 0;
	.user-component-badge {
		flex-shrink: 0;
	}
`;
